/** @jsxImportSource @emotion/react */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useAppSelector } from 'src/redux/hooks';

import { Box } from '@mui/material';
import { BrandLogo } from 'src/components';
import ReferFriendSuccess from './components/ReferFriendSuccess';
import ReferFriendForm from './components/ReferFriendForm';
import ReferFriendRejected from './components/ReferFriendRejected';

import { referFriendSelectors } from 'src/redux/referFriend';

import { logEvent } from 'src/services';

const ReferFriend: React.FC = () => {
  const wasRejected = useAppSelector(
    referFriendSelectors.getReferralSubmitWasRejected,
  );
  const isReferralInProcess = useAppSelector(
    referFriendSelectors.getReferralInProcess,
  );
  const referralName = useAppSelector(
    referFriendSelectors.getReferralSubmitName,
  );

  useEffect(() => {
    logEvent('launchpod - refer-friend-page_loaded');
  }, []);

  const [isReferralSubmitted, setIsReferralSubmitted] = useState(false);

  const onReferMoreFriendsClick = useCallback(
    () => setIsReferralSubmitted(false),
    [],
  );

  const onReferralSubmit = useCallback(() => setIsReferralSubmitted(true), []);

  const Component = useMemo(() => {
    if (!isReferralSubmitted)
      return <ReferFriendForm onReferralSubmit={onReferralSubmit} />;

    if (wasRejected)
      return (
        <ReferFriendRejected
          isReferralInProcess={isReferralInProcess}
          referralName={referralName}
          onReferMoreFriendsClick={onReferMoreFriendsClick}
        />
      );

    return (
      <ReferFriendSuccess onReferMoreFriendsClick={onReferMoreFriendsClick} />
    );
  }, [isReferralSubmitted, isReferralInProcess, wasRejected, referralName]);

  return (
    <Box
      sx={(theme) => ({
        background: isReferralSubmitted
          ? theme.palette.common.white
          : theme.palette.background.backgroundPrimary,
        minWidth: '100%',
        minHeight: '100%',
        padding: '41px 16px',
        [theme.breakpoints.down('lg')]: {
          paddingTop: '130px',
        },
      })}
    >
      <Box sx={{ position: 'absolute', top: '49px', left: '66px' }}>
        <BrandLogo width={133} />
      </Box>
      <Box display="flex" alignItems="center" flexDirection="column">
        {Component}
      </Box>
    </Box>
  );
};

export default ReferFriend;
